var map = {
	"./consult.js": "geee",
	"./distribution.js": "Zm4b",
	"./goods.js": "VKiZ",
	"./permission.js": "cCKo",
	"./publisher.js": "j9BD",
	"./userLogin.js": "0lsB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BOCG";


//////////////////
// WEBPACK FOOTER
// ./src/vuex/modules nonrecursive \.js$
// module id = BOCG
// module chunks = 42